import React, { useState } from 'react';
import cx from 'classnames';
import { Trans } from '@elevio/kb-kit/lib/components/trans';
import * as Search from '@elevio/kb-kit/lib/components/search';
import * as Categories from '@elevio/kb-kit/lib/components/categories';
import { useLanguages, useTranslation } from '@elevio/kb-kit/lib/hooks';
import { Logo } from './Logo';
import LoginLogout from './LoginLogout';
import LanguagePicker from './LanguagePicker';

function Header({ children, className, showSearch }) {
  const [displaySearchBar, setDisplaySearchBar] = useState(false);
  const [displayMobileMenu, setDisplayMobileMenu] = useState(false);
  const { t } = useTranslation();
  const { supportedLanguages, selectedLanguage, setCurrentLanguageId } =
    useLanguages();
  return (
    <header className="mega-menu">
      {/* <div className="container-fluid"> */}
      <div className="container bigger">
        <div className="row">
          <div className="col-lg-3 d-flex justify-content-between">
            <div className=" header-logo fit-logo-img add-header-height  logo-has-sticky">
              <a href="/" className="logo">
                  <Logo />
              </a>
            </div>
            <button
              className="d-lg-none hamburger hamburger--squeeze"
              type="button"
            >
              <span className="hamburger-box">
                {' '}
                <span className="hamburger-inner" />{' '}
              </span>
            </button>
          </div>

          <div className="col-lg-6 text-center d-flex justify-content-center">
            <div className="form-style-2">
              <div className="hs-form">
                <Search.Input
                  placeholder={'What do you need help with?'}
                  data-testid="search-input"
                  className="hero-search"
                  style={{ cursor: 'auto' }}
                />
              </div>
            </div>
          </div>

          <div className="col-md-3 align-items-center justify-content-end d-flex">
            <div className="menu-mega-menu-container">
              <ul id="menu-mega-menu" className="menu">
                <li
                  id="menu-item-29721"
                  className="trial-button menu-item menu-item-type-custom menu-item-object-custom menu-item-29721"
                >
                  <LoginLogout className="nav-desktop-menu-link login-button" />
                  {supportedLanguages.length > 1 && (
                    <LanguagePicker
                      selectedLanguageId={selectedLanguage.id}
                      setCurrentLanguageId={setCurrentLanguageId}
                      supportedLanguages={supportedLanguages}
                    />
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
